/* Progressive enhancement: product descriptions remain the authoritative content. */
(() => {
  if (customElements.get('pw-product-information')) return;

  class PWProductInformation extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        window.addEventListener('hashchange', this.openHash);
        this.openHash();
        return;
      }
      const source = this.querySelector('[data-pw-description]');
      if (!source) return;
      const sections = Array.from(source.children).filter(node => node.matches('.pw-section'));
      if (sections.length < 2) return;
      this.initialized = true;

      const groups = new Map(['overview', 'scent', 'use', 'details'].map(key => [key, []]));
      for (const node of Array.from(source.childNodes)) {
        let key = 'overview';
        if (node.nodeType === Node.ELEMENT_NODE && node.matches('.pw-section')) {
          // Structural markers survive translated product descriptions. Unknown
          // content stays visible in Overview; never discard an unrecognised block.
          const explicit = node.dataset.pwTab;
          if (groups.has(explicit)) key = explicit;
          else if (node.querySelector('.pw-scent')) key = 'scent';
          else if (node.querySelector('.pw-usage, .pw-steps')) key = 'use';
          else if (node.querySelector('.pw-specs, .pw-includes')) key = 'details';
          else if (node === sections.at(-1) && node.querySelector('.pw-label') && !node.querySelector('.pw-heading')) key = 'details';
        }
        groups.get(key).push(node);
      }

      const fragment = document.createDocumentFragment();
      this.disclosures = [];
      this.panels = [];
      for (const [key, nodes] of groups) {
        if (!nodes.some(node => node.nodeType === Node.ELEMENT_NODE && !node.matches('style, script'))) continue;
        const disclosure = document.createElement('details');
        disclosure.className = 'pw-product-information__item';
        const summary = document.createElement('summary');
        summary.id = `${this.id}-${key}-summary`;
        const hasSpecifications = key === 'details' && nodes.some(node =>
          node.nodeType === Node.ELEMENT_NODE && node.querySelector('.pw-specs'));
        summary.textContent = hasSpecifications ? (this.dataset.specifications || this.dataset[key]) : this.dataset[key];
        const panel = document.createElement('div');
        panel.id = `${this.id}-${key}-panel`;
        panel.className = 'pw-product-information__panel prose';
        panel.setAttribute('role', 'region');
        panel.setAttribute('aria-labelledby', summary.id);
        panel.append(...nodes);
        disclosure.append(summary, panel);
        fragment.append(disclosure);
        this.disclosures.push(disclosure);
        this.panels.push(panel);
      }
      source.replaceWith(fragment);
      this.openHash = () => {
        let id;
        try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
        if (!id) return;
        const target = document.getElementById(id);
        const index = this.panels.findIndex(panel => panel === target || panel.contains(target));
        if (index !== -1) this.disclosures[index].open = true;
      };
      this.openHash();
      window.addEventListener('hashchange', this.openHash);
    }

    disconnectedCallback() {
      if (this.openHash) window.removeEventListener('hashchange', this.openHash);
    }

  }
  customElements.define('pw-product-information', PWProductInformation);
})();
